import { Typography } from "@/components/atoms";
import { ClientPaymentMethod } from "@/redux/apis/clientPayment/types";
import { PaymentMethodRow } from "./PaymentMethodRow";
import { SummaryCard } from "./SummaryCard";

interface PaymentSummaryCardProps {
  method: ClientPaymentMethod | null;
  onEdit?: () => void;
  /** Purple "active" tint — the step currently being viewed/edited. Defaults to "has a method". */
  highlighted?: boolean;
  className?: string;
}

/** Payment card of the priced Booking Summary — purple tint once a method is selected (per Figma). */
export const PaymentSummaryCard = ({ method, onEdit, highlighted, className }: PaymentSummaryCardProps) => (
  <SummaryCard icon="Card" title="Payment" onEdit={onEdit} highlighted={highlighted ?? !!method} empty={!method} className={className}>
    {method ? (
      <PaymentMethodRow method={method} />
    ) : (
      <Typography variant="small-regular" className="text-neutral-dark-gray">
        No payment method selected yet
      </Typography>
    )}
  </SummaryCard>
);
